'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight, BedSingle, Calendar, Clock, HouseOutline, Leaf, Ticket, Train, TrainSeat, User } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { OverlayDrawer } from '~/components/Drawer';
import type { TripOverviewIncludedItem } from '../types';
import styles from './TripPriceBreakdownModal.module.css';
const INCLUDED_ICONS = [Train, BedSingle, Ticket, TrainSeat, Clock, Leaf] as const;
type TripPriceBreakdownModalProps = {
  isOpen: boolean;
  close: () => void;
  whatsIncluded: TripOverviewIncludedItem[];
  originCity: string;
  dateRange: string;
  travellerCount: number;
  rooms: number;
  nights: number;
};
export function TripPriceBreakdownModal(t0) {
  const $ = _c(79);
  const {
    isOpen,
    close,
    whatsIncluded,
    originCity,
    dateRange,
    travellerCount,
    rooms,
    nights
  } = t0;
  const t = useTranslations("journey");
  const commonT = useTranslations("common");
  const dayCount = nights + 1;
  const pricingNoteKey = rooms === 1 && travellerCount === 1 ? "price_details_pricing_note_solo" : "price_details_pricing_note_sharing";
  let t1;
  if ($[0] !== t) {
    t1 = t("price_details_aria_label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("includes_heading");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className={styles.sectionTitle}>{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== whatsIncluded) {
    t4 = whatsIncluded.map(_temp);
    $[6] = whatsIncluded;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ul className={styles.itemList}>{t4}</ul>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <section>{t3}{t5}</section>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <hr className={styles.divider} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("price_details_trip_details_heading");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <h2 className={styles.sectionTitle}>{t8}</h2>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className={styles.iconBadge} aria-hidden="true"><HouseOutline decorative={true} size="small" /></span>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== originCity || $[20] !== t) {
    t11 = t("price_details_origin", {
      city: originCity
    });
    $[19] = originCity;
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li className={styles.listItem}>{t10}<span className={styles.itemLabel}>{t11}</span></li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className={styles.iconBadge} aria-hidden="true"><Calendar decorative={true} size="small" /></span>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = dateRange ? "  /  " : "";
  let t15;
  if ($[25] !== dayCount || $[26] !== t) {
    t15 = t("price_details_day_count", {
      count: dayCount
    });
    $[25] = dayCount;
    $[26] = t;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <span className={styles.itemLabelMuted}>{t14}{t15}</span>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== dateRange || $[32] !== t16) {
    t17 = <li className={styles.listItem}>{t13}<span className={styles.itemLabel}>{dateRange}{t16}</span></li>;
    $[31] = dateRange;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className={styles.iconBadge} aria-hidden="true"><User decorative={true} size="small" /></span>;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t || $[36] !== travellerCount) {
    t19 = t("price_details_traveller_count", {
      count: travellerCount
    });
    $[35] = t;
    $[36] = travellerCount;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <li className={styles.listItem}>{t18}<span className={styles.itemLabel}>{t19}</span></li>;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t12 || $[41] !== t17 || $[42] !== t20) {
    t21 = <ul className={styles.itemList}>{t12}{t17}{t20}</ul>;
    $[40] = t12;
    $[41] = t17;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21 || $[45] !== t9) {
    t22 = <section>{t9}{t21}</section>;
    $[44] = t21;
    $[45] = t9;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <hr className={styles.divider} />;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className={styles.questionBadge} aria-hidden="true">?</span>;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== pricingNoteKey || $[50] !== rooms || $[51] !== t || $[52] !== travellerCount) {
    t25 = t(pricingNoteKey, {
      person_count: travellerCount,
      room_count: rooms
    });
    $[49] = pricingNoteKey;
    $[50] = rooms;
    $[51] = t;
    $[52] = travellerCount;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t25) {
    t26 = <p className={styles.pricingNoteText}>{t25}</p>;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t("price_details_learn_more");
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <ArrowUpRight decorative={true} size="small" />;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t27) {
    t29 = <a className={styles.learnMoreLink} href="/pricing" target="_blank" rel="noopener noreferrer">{t27} {t28}</a>;
    $[59] = t27;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t26 || $[62] !== t29) {
    t30 = <div className={styles.pricingNote}>{t24}<div>{t26}{t29}</div></div>;
    $[61] = t26;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== commonT) {
    t31 = commonT("okay");
    $[64] = commonT;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== close || $[67] !== t31) {
    t32 = <Button variant="primary" size="fullWidth" isPillShape={true} onPress={close}>{t31}</Button>;
    $[66] = close;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t22 || $[70] !== t30 || $[71] !== t32 || $[72] !== t6) {
    t33 = <div className={styles.root}>{t6}{t7}{t22}{t23}{t30}{t32}</div>;
    $[69] = t22;
    $[70] = t30;
    $[71] = t32;
    $[72] = t6;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== close || $[75] !== isOpen || $[76] !== t1 || $[77] !== t33) {
    t34 = <OverlayDrawer isOpen={isOpen} close={close} ariaLabel={t1} dataTestId="TripPriceBreakdownDrawer">{t33}</OverlayDrawer>;
    $[74] = close;
    $[75] = isOpen;
    $[76] = t1;
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  return t34;
}
function _temp(item, index) {
  const Icon = INCLUDED_ICONS[index % INCLUDED_ICONS.length];
  return <li key={item.id} className={styles.listItem}><span className={styles.iconBadge} aria-hidden="true"><Icon decorative={true} size="small" /></span><span className={styles.itemLabel}>{item.label}</span></li>;
}